import { Center as CkCenter, chakra } from "@chakra-ui/react";

export const ResetPasswordPopupContainer = chakra(CkCenter, {
  baseStyle: () => ({
    flexDirection: "column",
    marginTop: "30px",
  }),
});
